import React, { memo, useEffect } from 'react';
import classnames from 'classnames';
// @ts-ignore
import { merge } from 'lodash-es';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import {
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  LegendComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import useChart from '@gp/hooks/echarts/useChart';
import { BASE_ECHART_OPTION, Y_AXIS_NAME_CURRENCY_OPTION, Y_AXIS_NAME_CURRENCY_GRID_OPTION } from '@gp/constants/echarts';
import '@gp/pages/StudioDashboard/StudioOverall/components/StackBarChart/index.scss';

echarts.use([
  BarChart,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  CanvasRenderer,
  LegendComponent,
]);

const StackBarChart: React.FC<IEChartCompProps> = (props) => {
  const {
    data,
    getBarChartOptionData,
    legendFormatter,
    tootipFormatter,
    axisLabelOfXAxisFormatter,
    axisLabelOfYAxisFormatter,
    tooltipConfig,
    gridConfig,
    legendConfig,
    locale = 'en',
    className,
    style,
    ...remains
  } = props;

  /**
   * 1、初始化chart实例
   * 2、监听window的resize事件，处理echarts resize
   * 3、echart配置项变化时,更新echart UI
   */
  const { chartNode, setOption } = useChart({ locale });

  // 数据变化时,更新echart配置项
  useEffect(() => {
    const optionData = getBarChartOptionData?.(data);
    const newOption: IEChartOption = merge({}, BASE_ECHART_OPTION, {
      grid: {
        ...BASE_ECHART_OPTION.grid,
        ...gridConfig,
        ...Y_AXIS_NAME_CURRENCY_GRID_OPTION,
      },
      legend: {
        ...BASE_ECHART_OPTION.legend,
        ...legendConfig,
        formatter: legendFormatter,
      },
      tooltip: {
        ...BASE_ECHART_OPTION.tooltip,
        ...tooltipConfig,
        formatter: tootipFormatter,
      },
      xAxis: {
        ...BASE_ECHART_OPTION.xAxis,
        axisLabel: {
          // @ts-ignore
          ...BASE_ECHART_OPTION?.xAxis?.axisLabel,
          formatter: axisLabelOfXAxisFormatter,
        },
        // @ts-ignore
        data: optionData?.xAxis?.data || [],
      },
      yAxis: [
        {
          ...BASE_ECHART_OPTION?.yAxis?.[0],
          ...Y_AXIS_NAME_CURRENCY_OPTION,
          axisLabel: {
            // @ts-ignore
            ...BASE_ECHART_OPTION?.yAxis?.[0]?.axisLabel,
            formatter: axisLabelOfYAxisFormatter,
          },
        },
      ],
      series: optionData?.series || [],
      dataset: {
        dimensions: optionData?.dataset?.dimensions || [],
        source: optionData?.dataset?.source || [],
      },
    });
    setOption(newOption);
  }, [data]);

  return (
    <div
      {...remains}
      style={style}
      className={classnames('dbg-studio-overall-stack-chart-comp', className)}
    >
      <div ref={chartNode} className="chart-comp-chart-node"></div>
    </div>
  );
};

export default memo(StackBarChart);
